// extracted by mini-css-extract-plugin
export var angle = "fellowship-module--angle--953c0";
export var articleFooter = "fellowship-module--articleFooter--dc0e7";
export var cardGrid = "fellowship-module--cardGrid--68a77";
export var center = "fellowship-module--center--c2e00";
export var centerButtons = "fellowship-module--centerButtons--e9ede";
export var centerOnlyMobile = "fellowship-module--centerOnlyMobile--d74c4";
export var clearBg = "fellowship-module--clearBg--f1fba";
export var container = "fellowship-module--container--ce82e";
export var fellowshipStories = "fellowship-module--fellowshipStories--dde05";
export var imageMaxWidth100 = "fellowship-module--imageMaxWidth100--42c35";
export var inlineSocialShareMobile = "fellowship-module--inlineSocialShareMobile--afd6e";
export var logo = "fellowship-module--logo--c1512";
export var maxWidth1200 = "fellowship-module--maxWidth1200--fca37";
export var normalTextBlock = "fellowship-module--normalTextBlock--162f7";
export var paragraphs = "fellowship-module--paragraphs--3fce2";
export var relatedReading = "fellowship-module--relatedReading--d30ea";
export var sectionHeading = "fellowship-module--sectionHeading--42757";
export var sectionInset = "fellowship-module--sectionInset--1a7cd";
export var sectionItem = "fellowship-module--sectionItem--59b03";
export var shareArrowIcon = "fellowship-module--shareArrowIcon--7c8ab";
export var shareBlock = "fellowship-module--shareBlock--9cf4b";
export var shareText = "fellowship-module--shareText--dc5f6";
export var slideUp = "fellowship-module--slideUp--c1747";
export var slideUpLarge = "fellowship-module--slideUpLarge--2db69";
export var spacer = "fellowship-module--spacer--83173";
export var storyImg = "fellowship-module--storyImg--227fd";
export var storyTitle = "fellowship-module--storyTitle--f3f19";
export var threeColumn = "fellowship-module--threeColumn--171b5";
export var wrap = "fellowship-module--wrap--3d08d";
export var wrapDark = "fellowship-module--wrapDark--b0d0c";